export enum NetworkManagerEventType {
  AudiosPacket = 'NETWORK_MANAGER.AUDIOS_PACKET',
  BlockEditPredictionResultsPacket = 'NETWORK_MANAGER.BLOCK_EDIT_PREDICTION_RESULTS_PACKET',
  BlocksPacket = 'NETWORK_MANAGER.BLOCKS_PACKET',
  BlockTypesPacket = 'NETWORK_MANAGER.BLOCK_TYPES_PACKET',
  CameraPacket = 'NETWORK_MANAGER.CAMERA_PACKET',
  ChatMessagesPacket = 'NETWORK_MANAGER.CHAT_MESSAGE_PACKET',
  ChunksPacket = 'NETWORK_MANAGER.CHUNKS_PACKET',
  ConnectionPacket = 'NETWORK_MANAGER.CONNECTION_PACKET',
  EntitiesPacket = 'NETWORK_MANAGER.ENTITIES_PACKET',
  LightsPacket = 'NETWORK_MANAGER.LIGHTS_PACKET',
  NotificationPermissionRequestPacket = 'NETWORK_MANAGER.NOTIFICATION_PERMISSION_REQUEST_PACKET',
  ParticleEmittersPacket = 'NETWORK_MANAGER.PARTICLE_EMITTERS_PACKET',
  PhysicsDebugRaycastsPacket = 'NETWORK_MANAGER.PHYSICS_DEBUG_RAYCASTS_PACKET',
  PhysicsDebugRenderPacket = 'NETWORK_MANAGER.PHYSICS_DEBUG_RENDER_PACKET',
  PlayersPacket = 'NETWORK_MANAGER.PLAYERS_PACKET',
  SceneUIsPacket = 'NETWORK_MANAGER.SCENE_UIS_PACKET',
  SyncResponsePacket = 'NETWORK_MANAGER.SYNC_RESPONSE_PACKET',
  UIPacket = 'NETWORK_MANAGER.UI_PACKET',
  UIDatasPacket = 'NETWORK_MANAGER.UI_DATAS_PACKET',
  WorldPacket = 'NETWORK_MANAGER.WORLD_PACKET',
}
